import { useState,  useRef, useEffect } from "react";


type Props = {
  stream: MediaStream;
  isRecording: boolean;
};
export default function LiveBarWaveformMoving({ stream, isRecording }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const audioContextRef = useRef<AudioContext | null>(null);
  const analyserRef = useRef<AnalyserNode | null>(null);
  const animationFrameRef = useRef<number>();

  useEffect(() => {
    if (!isRecording || !stream || !canvasRef.current) return;

    const canvas = canvasRef.current!;
    const ctx = canvas.getContext("2d")!;
    const containerWidth = canvas.getBoundingClientRect().width;
    const containerHeight = 40; // altura fixa visual

    const dpr = window.devicePixelRatio || 1;
    canvas.width = containerWidth * dpr;
    canvas.height = containerHeight * dpr;
    canvas.style.width = `${containerWidth}px`;
    canvas.style.height = `${containerHeight}px`;
    ctx.scale(dpr, dpr);

    const audioCtx = new AudioContext();
    const analyser = audioCtx.createAnalyser();
    analyser.fftSize = 64;
    const source = audioCtx.createMediaStreamSource(stream);
    source.connect(analyser);

    const dataArray = new Uint8Array(analyser.frequencyBinCount);

    const gap = 2;
    const barWidth = 2;
    const totalBars = Math.floor(containerWidth / (barWidth + gap));
    const barHeights = new Array(totalBars).fill(0);

    function draw() {
      animationFrameRef.current = requestAnimationFrame(draw);

      analyser.getByteFrequencyData(dataArray);
      const volume = dataArray.reduce((sum, v) => sum + v, 0) / dataArray.length;
      const normalized = volume / 255;

      for (let i = 0; i < barHeights.length - 1; i++) {
        barHeights[i] = barHeights[i + 1];
      }

      barHeights[barHeights.length - 1] = normalized;

      ctx.clearRect(0, 0, containerWidth, containerHeight);

      barHeights.forEach((val, i) => {
        const h = val * containerHeight;
        const x = i * (barWidth + gap);
        const y = (containerHeight - h) / 2;
        ctx.fillStyle = "#2563eb";
        ctx.fillRect(x, y, barWidth, h);
      });
    }

    draw();

    audioContextRef.current = audioCtx;
    analyserRef.current = analyser;

    return () => {
      cancelAnimationFrame(animationFrameRef.current!);
      audioCtx.close();
    };
  }, [stream, isRecording]);

  return (
    <canvas
      ref={canvasRef}
      style={{
        width: "100%",
        height: "40px",
        borderRadius: 8,
        // background: "#ffffff",
        display: "block",
      }}
    />
  );
}
